import { createContext } from 'react'

export type SearchContextType = {
  value: string
  setValue: (value: string) => void
}

export const SearchContext = createContext<SearchContextType | undefined>(undefined)
